import { current } from '@reduxjs/toolkit'
import { FormMetaData, FormSchemaMetaData, MetaDataMap, ValidatorMetaMap } from './formInterfaces'

export enum FormActionKind {
    setSchema = 'setSchema',
    setMetaDataMap = 'setMetaDataMap',
    setValidatorMetaMap = 'setValidatorMetaMap',
    setDataObjectId = 'setDataObjectId',
    setGuid = 'setGuid',
    setTabGuid = 'setTabGuid',
    setLockedData = 'setLockedData',
    setIsReadOnly = 'setIsReadOnly',
    setTemplateType = 'setTemplateType',
    setIsCopyPasted = 'setIsCopyPasted',
    setLockedStatusMsg = 'setLockedStatusMsg',
    setIsNavigationEnabled = 'setIsNavigationEnabled',
    setOCVData = 'setOCVData',
    setLockedStatus = 'lockedStatus',
    setFieldInstances = 'setFieldInstances',
    setIsSaved = 'setIsSaved',
    updateFieldInstance = 'updateFieldInstance',
    updateFieldFile = 'updateFieldFile',
}

interface FormAction {
    type: FormActionKind
    payload: any
}

interface FieldAction {
    type: 'setFieldInstances' | 'updateFieldFile' | 'updateFieldInstance'
    payload: any
}

// TODO respond in a state based way to every field change in every component
export interface FormState {
    schema: FormSchemaMetaData
    templateType: string
    MetaDataMap: MetaDataMap
    validatorMetaMap: ValidatorMetaMap
    isReadOnly?: boolean
    lockedData?: { [s: string]: any }
    toggleBtnTxt?: string
    dataObjectId: string
    tabGuid?: string
    guid?: string
    lockedStatusMsg?: string
    isCopyPasted?: string
    isNavigationEnabled: string
    ocvData?: { [s: string]: any }
    lockedStatus?: boolean
    isSaved?: boolean
    addAuditComment: (s: string) => void
    // count: number;
}

export interface FieldState {
    fieldInstances?: { [s: string]: any }[]
    fieldFiles?: { [id: string]: any }
}

export const formReducer = (state: FormState, action: FormAction): FormState => {
    const { type, payload } = action
    switch (type) {
        case FormActionKind.setSchema:
            return {
                ...state,
                schema: payload,
            }
        case FormActionKind.setTemplateType:
            return {
                ...state,
                templateType: payload,
            }
        case FormActionKind.setMetaDataMap:
            return {
                ...state,
                MetaDataMap: payload,
            }
        case FormActionKind.setValidatorMetaMap:
            return {
                ...state,
                validatorMetaMap: payload,
            }
        case FormActionKind.setDataObjectId:
            return {
                ...state,
                dataObjectId: payload,
            }
        case FormActionKind.setGuid:
            return {
                ...state,
                guid: payload,
            }
        case FormActionKind.setTabGuid:
            return {
                ...state,
                tabGuid: payload,
            }
        case FormActionKind.setLockedData:
            return {
                ...state,
                lockedData: payload,
            }
        case FormActionKind.setIsReadOnly:
            return {
                ...state,
                isReadOnly: payload,
            }
        case FormActionKind.setIsCopyPasted:
            return {
                ...state,
                isCopyPasted: payload,
            }
        case FormActionKind.setLockedStatusMsg:
            return {
                ...state,
                lockedStatusMsg: payload,
            }
        case FormActionKind.setIsNavigationEnabled:
            return {
                ...state,
                isNavigationEnabled: payload,
            }
        case FormActionKind.setOCVData:
            return {
                ...state,
                ocvData: payload,
            }
        case FormActionKind.setLockedStatus:
            return {
                ...state,
                lockedStatus: payload,
            }
        case FormActionKind.setIsSaved:
            return {
                ...state,
                isSaved: payload,
            }
        default:
            return state
    }
}

export const fieldReducer = (state: FieldState, action: FieldAction): FieldState => {
    const { type, payload } = action
    switch (type) {
        case FormActionKind.setFieldInstances:
            return {
                ...state,
                fieldInstances: payload,
            }
        case FormActionKind.updateFieldFile:
            let currentFieldFiles = state.fieldFiles || {} 
            currentFieldFiles[payload.fileId] = payload.file
            
            return {
                ...state,
                fieldFiles: currentFieldFiles,
            }
        // Hacky, should revisit later
        // attribute is which value on the field to change
        // newValue is the value to set that attribute to
        // setIndex is the index of the set in the fieldInstances
        // fieldIndex is the index of the field in the set
        case FormActionKind.updateFieldInstance:
            const { newValue, fieldId, setIndex, fieldIndex, attribute } = payload
            const currentFieldInstances = state.fieldInstances
            if (currentFieldInstances !== undefined) {
                let currentField = currentFieldInstances[setIndex].fields[fieldIndex]
                if (currentField.id === fieldId) {
                    currentField[attribute] = newValue
                    currentFieldInstances[setIndex].fields[fieldIndex] = currentField
                } else {
                    console.error('Field index and id do not match. Error finding field')
                }
            }
            return {
                ...state,
                fieldInstances: currentFieldInstances,
            }
        default:
            return state
    }
}
